module.exports = __webpack_public_path__ + "img/imgp8790.320fd57e.jpg";